import { createSelector } from '@reduxjs/toolkit'
import { pickBy, values } from 'lodash-es'

function getBase(state) {
  return state.data.users
}

export function getUsers(state, props) {
  return getBase(state).entities
}

export function getUser(state, props) {
  const { userId } = props
  const users = getUsers(state, props)
  const idString = userId.toString()
  return users[idString] || null
}

export function getCurrentUser(state, props) {
  const base = getBase(state)
  const userId = base.currentUserId
  if (userId && userId !== 0) {
    const idString = userId.toString()
    return base.entities[idString] || null
  }
  return null
}

export const getUsersByIds = createSelector(
  (state, props) => props, // array of user ids
  getUsers,
  function (userIds, allUsers) {
    const userIdSet = new Set(userIds.map(String)) // Convert all user IDs to strings
    return pickBy(allUsers, (user, userId) => userIdSet.has(userId))
  }
)

export const getUsersListByIds = createSelector(getUsersByIds, usersArray => {
  return values(usersArray)
})
